var SDrawer = function (options) {
  if (!options) {
    options = {};
  }
  this.body = document.body;
  this.btn = document.getElementById(options.btn) || document.getElementById('drawer-btn');
  if (!options.cover) {
    options.cover = 'drawer-cover';
  }
  this.cover = this.createCover(options.cover);
  this.wrap = document.getElementById(options.wrap) || document.getElementById('drawer-wrap');
  this.size = options.size || '70%';
  this.direct = options.direct || 'right';
};

SDrawer.prototype = {
  createCover: function (coverId) {
    /* ===================================
      カバーを作成
    =================================== */
    var cover = document.createElement('div');
    cover.id = coverId;
    cover.style.display = 'none';
    this.body.appendChild(cover);
    return cover;
  },
  initializeDrawer: function () {
    /* ===================================
      ドロワーを初期化
    =================================== */
    this.wrap.style.width = this.size;
    if (this.direct == 'left') {
      this.wrap.classList.add('drawer-left');
    } else {
      this.wrap.classList.add('drawer-right');
    }
  },
  toggleDrawer: function () {
    /* ===================================
      ドロワーの表示・非表示
    =================================== */
    this.wrap.style.width = this.size;
    if (this.direct == 'left') {
      this.wrap.classList.add('drawer-left');
    } else {
      this.wrap.classList.add('drawer-right');
    }
  },
  bodySticky: function () {
    /* ===================================
      スクロール止める
    =================================== */
    var bodyTop = window.pageYOffset;
    this.body.style.top = -bodyTop + 'px';
    return bodyTop;
  },
  toggleMenu: function () {
    /* ===================================
      bodyに.drawer-openを付与・削除 
      div.drawer-coverの表示・非表示
    =================================== */

    if (this.body.classList.contains('drawer-open')) {
      this.body.classList.remove('drawer-open');
      window.scrollTo(0, this.bodyTop);
      this.body.classList.add('drawer-close');
      this.cover.addEventListener(
        'animationend',
        function () {
          this.style.display = 'none';
        },
        { once: true },
        false
      );
      if (this.direct == 'left') {
        this.wrap.style.right = '';
      } else {
        this.wrap.style.left = '';
      }
    } else {
      this.cover.style.display = 'block';
      this.bodyTop = this.bodySticky();

      this.body.classList.remove('drawer-close');
      this.body.classList.add('drawer-open');
      if (this.direct == 'left') {
        this.wrap.style.right = 'calc(100% - ' + this.size + ')';
      } else {
        this.wrap.style.left = 'calc(100% - ' + this.size + ')';
      }
    }
  },
  switchsClick: function () {
    /* ===================================
      ボタンとカバーをクリックした時の処理
    =================================== */
    var _this = this;
    var switchs = [this.btn, this.cover];
    for (var i = 0, len = switchs.length; i < len; i++) {
      switchs[i].addEventListener(
        'click',
        function () {
          _this.toggleMenu.call(_this);
        },
        false
      );
    }
  },
  active: function () {
    this.initializeDrawer();
    this.switchsClick();
  },
};
